export function generateQueryString(object) {
  if (!object) return "";
  return `?${Object.keys(object)
    .map(key => key + "=" + object[key])
    .join("&")}`;
}

export function generateFilterValueQueryString(category, object) {
  if (!object) return `/${category}`;

  return `/${category}?${Object.keys(object)
    .map(key => {
      if (key !== category) {
        if (Array.isArray(object[key]) && object[key].length > 0) {
          return object[key].map(item => key + "=" + item).join("&");
        } else {
          return key + "=" + object[key];
        }
      }
    })
    .join("&")}`;
}
